export default "__VITE_ASSET__4_A$RAju__"